import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_mto_component_option_compatibility_line_RowClass } from '../../../dbschema';

export class MTOComponentOptionCompatibilityLineContainerModel extends BaseContainerModel {
  bl_fi_mto_component_option_compatibility_line: bl_fi_mto_component_option_compatibility_line_RowClass = new bl_fi_mto_component_option_compatibility_line_RowClass();
}